export enum Currency {
    CZK = 1,
    EUR = 2,
    PLN = 3,
}

export default new class CurrencyFormatter {
    public formatCurrencyWithSymbol(value: number, currencyId: Currency): string {
        const formattedValue = this.formatNumber(value, 2);

        switch (currencyId) {
            case Currency.CZK:
                return `${formattedValue} Kč`;

            case Currency.EUR:
                return `€ ${formattedValue}`;

            case Currency.PLN:
                return `${formattedValue} zł`;

            default:
                throw new Error("Invalid currency ID");
        }
    }

    public formatSymbol(currencyId: Currency): string {
        switch (currencyId) {
            case Currency.CZK:
                return "Kč";

            case Currency.EUR:
                return "€";

            case Currency.PLN:
                return "zł";

            default:
                throw new Error("Invalid currency ID");
        }
    }

    public formatNumber(value: number, decimals: number): string {
        if (Math.round(value) === value) {
            decimals = 0;
        }

        const x = value.toFixed(decimals).split(".");

        let x1 = x[0] ?? "";
        const decimalPart = decimals === 0
            ? (x.length > 1 ? `,${x[1]}` : "")
            : `,${x[1]}`;
        const rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, "$1 $2");
        }

        return x1 + decimalPart;
    }
}();
